module.exports = __webpack_public_path__ + "static/media/Proje_Sec_Kurulus_Osman.6864df5b.png";